/* eslint-disable */
// https://github.com/glidejs/glide/issues/434
export function VisibleClass (Glide, Components, Events) {
	var Component = {
		mount () {
			this.setVisibleClasses();
		},
		
		setVisibleClasses () {
			if (Glide.settings.perView > 1) {
				const glideEl = Components.Html.root;
				const active = Components.Html.slides[Glide.index];

				// Calculate how many on each side we need to add visible classes to
				if (Glide.settings.focusAt === 'center') {
					var numBefore = Math.ceil((Glide.settings.perView - 1) / 2);
					var numAfter = numBefore;
				}
				else {
					var numBefore = Glide.settings.focusAt;
					var numAfter = Glide.settings.perView - Glide.settings.focusAt - 1;
				}

				// Remove visible classes
				glideEl.querySelectorAll('.glide__slide--visible').forEach(slide => {
					slide.classList.remove('glide__slide--visible');
				});

				// Add visible class to active slide
				active.classList.add('glide__slide--visible');

				// Add visible classes to next siblings
				var next = active.nextElementSibling;

				if (next) {
					next.classList.add('glide__slide--visible');

					for (let i = 0; i < numAfter - 1; i++) {
						next = next.nextElementSibling;

						if (next) {
							next.classList.add('glide__slide--visible');
						}
					}
				}

			}
			else {
				Components.Html.root.querySelectorAll('.glide__slide--visible').forEach(slide => {
					slide.classList.remove('glide__slide--visible');
				});
				Components.Html.slides[Glide.index].classList.add('glide__slide--visible');
			}
		}
	};

    Events.on('run.after', () => {
		Component.setVisibleClasses();      
	});
	Events.on('resize', () => {
		Component.setVisibleClasses(); 
	});

	return Component;
};

// https://stackoverflow.com/a/61889895/19123420
export function DisableControls(Glide, Components, Events) {
	const PREV_CONTROL_SELECTOR = "[data-glide-dir='<']";
	const NEXT_CONTROL_SELECTOR = "[data-glide-dir='>']";
	const component = {
		buildAfter() {
		this.prevBtn = Components.Html.root.querySelector(PREV_CONTROL_SELECTOR);
		this.nextBtn = Components.Html.root.querySelector(NEXT_CONTROL_SELECTOR);
		},
		handleDisable() {
		const perView = Glide.settings.perView;
		const slidesCount = Components.Html.slides.length;

		this.prevBtn.disabled = (Glide.index <= 0);
		this.nextBtn.disabled = (Glide.index >= slidesCount - perView);
		},
	};

	Events.on("build.after", function () {
		component.buildAfter();
		component.handleDisable();
	});
	Events.on("run.after", function () {
		component.handleDisable();
	});
	return component;
}

export function LoadingClass(Glide, Components, Events){

	var Component = {
		removeLoadingClass () {
			Components.Html.root.classList.remove("card-carousel--loading")
		}
	};

	Events.on('mount.after', function () {
		Component.removeLoadingClass(); 
	})

	return Component;
}

export function preventVerticalScroll(Glide, Components, Events){

	var Component = {
		preventDefault (e) {
			e.preventDefault();
		}
	};

	Events.on(['move'], () => {
		document.body.addEventListener('touchmove', Component.preventDefault, { passive: false });
	});
	
	Events.on(['move.after'], () => {
		document.body.removeEventListener('touchmove', Component.preventDefault);
	});

	return Component;
}

// Reference https://github.com/glidejs/glide/issues/307
export const ArrowDisabler = function (Glide, Components, Events) {
    const Component = {
        mount() {
            // Only in effect when rewinding is disabled
            if (Glide.settings.rewind) {
                return;
            }

            Glide.on(['mount.after', 'run'], () => {
                // Filter out arrows_control
                for (const controlItem of Components.Controls.items) {
                    if (controlItem.className !== 'glide__arrows') {
                        continue;
                    }

                    // Set left arrow state
                    const left = controlItem.querySelector(
                        '.glide__arrow--left'
                    );
                    left.setAttribute('disabled', 'true');

                    if (left) {
                        if (Glide.index === 0) {
                            left.style.opacity = '0.5';
                            left.setAttribute('disabled', true); // Disable on first slide
                        } else {
                            left.style.opacity = '1';
                            left.removeAttribute('disabled'); // Enable on other slides
                        }
                    }

                    // Set right arrow state
                    const right = controlItem.querySelector(
                        '.glide__arrow--right'
                    );
                    if (right) {
                        if (
                            Glide.index ===
                            Components.Sizes.length - Glide.settings.perView
                        ) {
                            right.style.opacity = '0.5';
                            right.setAttribute('disabled', true); // Disable on last slide
                        } else {
                            right.style.opacity = '1';
                            right.removeAttribute('disabled'); // Disable on other slides
                        }
                    }
                }
            });
        },
    };

    Events.on('run.after', () => {
        return Component;
    });

    Events.on('resize', () => {
        return Component;
    });

    return Component;
};
